import QuickQuoteLogAdmin from "./quickQuoteLog"
import { Consumer, Provider, QuickQuoteLogContext } from "./quickQuoteLog.context"

export { Consumer, Provider, QuickQuoteLogContext }
export default QuickQuoteLogAdmin
